import { createApp } from 'vue'
import 'uno.css'
import '@mogic/dv-design/style'
import { loadIconFont } from '@mogic/dv-design'
import { windowsCancelReject, pauseOtherVideo } from '@da-vinci/utils'
import VueDomPurifyHtml from 'vue-dompurify-html'

import { store } from '@/store'
import { router } from '@/router'
import { i18n } from '@/locales'

import App from './App.vue'
import { initArms } from './utils/rum'
import { useEventListener } from '@da-vinci/hooks'
import { getConfig } from '@/utils'

loadIconFont()
getConfig()
async function bootstrap() {
  const app = createApp(App)

  app.use(i18n)
  app.use(store)
  app.use(router)
  app.use(VueDomPurifyHtml)
  app.mount('#app')
  windowsCancelReject(app)
  useEventListener(document, 'visibilitychange', () => {
    if (document.hidden) {
      pauseOtherVideo()
    }
  })
  // 接入阿里云用户体验监控
  initArms()
}

bootstrap()
